/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UploadLogoImage$Params {
  clientID: number;
  logo: string;
      body?: {
'file'?: Blob;
}
}

export function UploadLogoImage(http: HttpClient, rootUrl: string, params: UploadLogoImage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, UploadLogoImage.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.path('logo', params.logo, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

UploadLogoImage.PATH = '/api/Clients/UploadLogoImage/{clientID}/{logo}';
